import { useMemo } from "react";
import type { ContactDetailResponseDto } from "@shared/generated/crm/models/ContactDetailResponseDto";
import { deriveLatestPendingFieldSignalAt } from "./contacts-helpers";
import {
  getContactWithPendingChangesetQueryResponseSchema,
  useGetContactWithPendingChangeset,
} from "@shared/generated/crm";
import {
  buildContactFields,
  countPendingSuggestionsAgainstValues,
} from "./components/ContactBriefingHeader/contact-fields-helpers";

export const useContactPendingSuggestions = (
  contact: ContactDetailResponseDto,
) => {
  const { data: contactWithPendingChangeset } =
    useGetContactWithPendingChangeset(contact.id, undefined, {
      query: {
        enabled: !!contact.id,
        select: (data) =>
          getContactWithPendingChangesetQueryResponseSchema.parse(data),
      },
    });

  const pendingContactChangeset =
    contactWithPendingChangeset?.pendingContactChangeset;

  const contactFields = useMemo(
    () => buildContactFields(contact, pendingContactChangeset),
    [contact, pendingContactChangeset],
  );

  const pendingSuggestionsCount = useMemo(
    () =>
      countPendingSuggestionsAgainstValues(
        contactFields,
        Object.fromEntries(contactFields.map((f) => [f.id, f.value])),
      ),
    [contactFields],
  );

  const latestPendingFieldSignalAt = useMemo(
    () =>
      deriveLatestPendingFieldSignalAt(
        pendingContactChangeset?.contactFieldSignals ?? [],
      ),
    [pendingContactChangeset],
  );

  return {
    contactFields,
    pendingContactChangeset,
    pendingSuggestionsCount,
    latestPendingFieldSignalAt,
  };
};
